/**
 * Logica pura del collegamento chat WhatsApp -> Lead/Cliente per numero
 * (niente React ne' Supabase: i test girano in node).
 */

/** Scheda con lo stesso numero della chat, con quello che serve per scegliere. */
export interface ChatNumberCandidate {
  id: string;
  name: string;
  kind: 'Lead' | 'Cliente';
  numbers: string[];
  stageName: string | null;
  stageColor: string | null;
  /** null = nessun assegnatario */
  assigneeName: string | null;
}

const MIN_DIGITS = 8;

/**
 * Cifre del numero di una chat individuale. Vuoto per gruppi (@g.us), canali,
 * identificativi @lid (non sono numeri di telefono) e numeri troppo corti.
 */
export function chatNumberDigits(chatJid: string | null | undefined): string {
  const jid = (chatJid || '').trim();
  if (!jid) return '';
  const [local, domain = ''] = jid.split('@');
  if (domain && domain !== 'c.us' && domain !== 's.whatsapp.net') return '';
  const digits = local.replace(/\D/g, '');
  return digits.length >= MIN_DIGITS ? digits : '';
}

/**
 * Testo da cercare fra le schede: senza il 39 davanti, cosi' si trovano sia i numeri
 * salvati col prefisso sia quelli senza (la ricerca e' "contiene").
 */
export function searchTermForDigits(digits: string): string {
  return digits.startsWith('39') && digits.length > 10 ? digits.slice(2) : digits;
}

/** Stesso numero, col prefisso o senza (uno finisce con l'altro), almeno 8 cifre in comune. */
export function sameNumber(a: string, b: string): boolean {
  if (a.length < MIN_DIGITS || b.length < MIN_DIGITS) return false;
  return a === b || a.endsWith(b) || b.endsWith(a);
}

/** Tiene solo le schede che hanno davvero il numero della chat (la ricerca trova anche per nome). */
export function filterByChatNumber<T extends { numbers: string[] }>(digits: string, rows: T[]): T[] {
  if (!digits) return [];
  return rows.filter((r) => r.numbers.some((n) => sameNumber(n.replace(/\D/g, ''), digits)));
}

/** Etichetta del pulsante quando il numero e' su piu' schede. */
export function matchCountLabel(count: number): string {
  return count === 1 ? '1 scheda con questo numero' : `${count} schede con questo numero`;
}

/** Seconda riga di una scheda nell'elenco: "Lead · Nuovo contatto · Mario Rossi". */
export function candidateDetails(c: Pick<ChatNumberCandidate, 'kind' | 'stageName' | 'assigneeName'>): string {
  const parts: string[] = [c.kind];
  if (c.stageName) parts.push(c.stageName);
  parts.push(c.assigneeName || 'Senza assegnatario');
  return parts.join(' · ');
}
